import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';

@Component({
  selector: 'app-course-level-content-card',
  templateUrl: './course-level-content-card.component.html',
  styleUrls: ['./course-level-content-card.component.scss']
})
export class CourseLevelContentCardComponent implements AfterViewInit {
  imageUrl: string = "../../assets/images/yx8h6prm3pfpcppq53wa.png";
  imageAltName: string = "Image Alt Name";
  title: string = "Normal card";
  title2: string = "Cards With Links";
  subtitle: string = "Share It!, Level 5";
  startDateLabel: string = "Start Date:";
  startDate: string = "15th September 2021";
  endDateLabel: string = "End Date:";
  endDate: string = "15th September 2023";
  courseLevelCardWithLinkId: string = 'courseLevelCardWithLinkId';
  courseContentList: any[] = [
    {
      id: "normalCard1",
      name: "normalCard",
      value: "normalCard1",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 1",
      cardTitle: "Normal Card 1",
      ariaLabel: "normalCard1",
      configList: ['Learn more', 'Reading view']
    },
    {
      id: "normalCard2",
      name: "normalCard",
      value: "normalCard2",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 2",
      cardTitle: "Normal Card 2",
      ariaLabel: "normalCard2",
      configList: ['Learn more']
    },
    {
      id: "normalCard3",
      name: "normalCard",
      value: "normalCard3",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 3",
      cardTitle: "Normal Card 3",
      ariaLabel: "normalCard3",
      configList: ['Reading view']
    },
    {
      id: "normalCard4",
      name: "normalCard",
      value: "normalCard4",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 4",
      cardTitle: "Normal Card 4",
      ariaLabel: "normalCard4"
    },
    {
      id: "normalCard5",
      name: "normalCard",
      value: "normalCard5",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 5",
      cardTitle: "Normal Card 5",
      ariaLabel: "normalCard5"
    },
    {
      id: "normalCard6",
      name: "normalCard",
      value: "normalCard6",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 6",
      cardTitle: "Normal Card 6",
      ariaLabel: "normalCard6"
    }
  ];
 
  courseContentWithLinkList: any[] = [
    {
      id: "ABCNPD-cardWithLink1",
      name: "cardWithLink",
      value: "cardWithLink1",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Card with Link 1",
      cardTitle: "Card with Link 1",
      ariaLabel: "cardWithLink1",
      targetUrl: '/button'
    },
    {
      id: "ABCPD-cardWithLink2",
      name: "cardWithLink",
      value: "cardWithLink2",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Card with Link 2",
      cardTitle: "Card with Link 2",
      ariaLabel: "cardWithLink2",
      targetUrl: '/toast'
    },
    {
      id: "ABCRB-cardWithLink3",
      name: "cardWithLink",
      value: "cardWithLink3",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Card with Link 3",
      cardTitle: "Card with Link 3",
      ariaLabel: "cardWithLink3",
      targetUrl: '/dialog'
    }
  ];

  imageUrlSpanish: string = "../../assets/images/yx8h6prm3pfpcppq53wa.png";
  imageAltNameSpanish: string = "Nombre alternativo de la imagen";
  titleSpanish: string = "Tarjeta normal";
  subtitleSpanish: string = "Compártelo!, Nivel 5";
  startDateLabelSpanish: string = "Fecha de inicio:";
  startDateSpanish: string = "15 sept de 2021";
  endDateLabelSpanish: string = "Fecha final:";
  endDateSpanish: string = "15 sept de 2023";
  courseContentListSpanish: any[] = [
    {
      id: "tarjetaNormal1",
      name: "tarjetaNormal",
      value: "tarjetaNormal1",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Tarjeta normal 1",
      cardTitle: "Tarjeta normal 1",
      ariaLabel: "tarjetaNormal1"
    },
    {
      id: "tarjetaNormal2",
      name: "tarjetaNormal",
      value: "tarjetaNormal2",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Tarjeta normal 2",
      cardTitle: "Tarjeta normal 2",
      ariaLabel: "tarjetaNormal2"
    },
    {
      id: "tarjetaNormal3",
      name: "tarjetaNormal",
      value: "tarjetaNormal3",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Tarjeta normal 3",
      cardTitle: "Tarjeta normal 3",
      ariaLabel: "tarjetaNormal3"
    }
  ];

  imageUrlHindi: string = "../../assets/images/yx8h6prm3pfpcppq53wa.png";
  imageAltNameHindi: string = "छवि ऑल्ट नाम";
  titleHindi: string = "सामान्य कार्ड";
  subtitleHindi: string = "इसे साझा करें!, स्तर 5";
  startDateLabelHindi: string = "आरंभ तिथि:";
  startDateHindi: string = "15 सितंबर 2021";
  endDateLabelHindi: string = "समाप्ति तिथि:";
  endDateHindi: string = "15 सितंबर 2023";
  courseContentListHindi: any[] = [
    {
      id: "सामान्यकार्ड1",
      name: "सामान्यकार्ड",
      value: "सामान्यकार्ड1",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "सामान्य कार्ड 1",
      cardTitle: "सामान्य कार्ड 1",
      ariaLabel: "सामान्यकार्ड1"
    },
    {
      id: "सामान्यकार्ड2",
      name: "सामान्यकार्ड",
      value: "सामान्यकार्ड2",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "सामान्य कार्ड 2",
      cardTitle: "सामान्य कार्ड 2",
      ariaLabel: "सामान्यकार्ड2"
    },
    {
      id: "सामान्यकार्ड3",
      name: "सामान्यकार्ड",
      value: "सामान्यकार्ड3",
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "सामान्य कार्ड 3",
      cardTitle: "सामान्य कार्ड 3",
      ariaLabel: "सामान्यकार्ड3"
    }
  ];

  imageUrlWithAccordian: string = "../../assets/images/yx8h6prm3pfpcppq53wa.png";
  imageAltNameWithAccordian: string = "Image Alt Name";
  titleWithAccordian: string = "Normal card";
  title2WithAccordian: string = "Cards With Links";
  subtitleWithAccordian: string = "Share It!, Level 5";
  startDateLabelWithAccordian: string = "Start Date:";
  startDateWithAccordian: string = "15th September 2021";
  endDateLabelWithAccordian: string = "End Date:";
  endDateWithAccordian: string = "15th September 2023";
  courseContentLisWithAccordiant: any[] = [
    {
      id: "normalCard1",
      name: "normalCard",
      value: "normalCard1",
      subTitle:'Summer recap activities',
      chipLable:'Active',
      chipId:'active1',
      chipState:false,
      chipIcon:'',
      chipIconText:'',
      chipStatus:'primary',
      chipAriaLable:'active',
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 1",
      cardTitle: "Normal Card 1",
      ariaLabel: "normalCard1"
    },
    {
      id: "normalCard2",
      name: "normalCard",
      value: "normalCard2",
      subTitle:'Course B',
      chipLable:'Active',
      chipId:'active',
      chipState:false,
      chipIcon:'',
      chipIconText:'',
      chipStatus:'primary',
      chipAriaLable:'active',
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 2",
      cardTitle: "Normal Card 2",
      ariaLabel: "normalCard2"
    },
    {
      id: "normalCard3",
      name: "normalCard",
      value: "normalCard3",
      subTitle:'Course C',
      chipLable:'Past',
      chipId:'past',
      chipState: true,
      chipIcon:'',
      chipIconText:'',
      chipStatus:'',
      chipAriaLable:'past',
      imageUrl: "../../assets/images/yx8h6prm3pfpcppq53wa.png",
      imageAltName: "Normal Card 3",
      cardTitle: "Normal Card 3",
      ariaLabel: "normalCard3"
    }
  ];
  hasContentBelow = true;
  hasIconLeftSide = true;
  hasActions = true;
  hasDefaultExpanded = false;
  collapseLabel = 'Collapse';
  expandLabel = 'Expand';
  selectedSize = 'small';
  selectedStatus = 'default';
  hasCloseButton = false;
  hasOutline = true;
  disabled = false;
  hasStatusIcon = true;
  icon = '';
  ariaLabel = 'Chips';
  iconText = 'icon name';

  constructor(@Inject(DOCUMENT) private document: Document ) {}
  ngAfterViewInit(){
    const chipElement = this.document.querySelectorAll('.c-chip');
    if(chipElement){
      Array.from(chipElement).forEach(element =>{
        element.removeAttribute('tabindex');
        element.removeAttribute('aria-label');
        element.removeAttribute('aria-disabled');
      })
    }
  }
}